import * as Accountant from 'app/calcs/Accountant'
import { CommonPensionCalculations } from 'app/calcs/pensions'
import { ICommonPensionInputs, IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { ageAtAsDuration, deadBy, IRetirementPerson, Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { getBrandInfo } from 'config'
import * as _ from 'lodash'
import * as moment from 'moment'

interface INcpersPriorPensionInputs extends ICommonPensionInputs {
  pensionAmount: number
  kind: SimplePensionFormOfPayment
  isFromNonCoveredEmployment: boolean
}

class NCPERSPriorPensionCalculations extends CommonPensionCalculations<INcpersPriorPensionInputs> {

  constructor(profile: Profile) {
    super(profile, getBrandInfo().priorPensionTimelineLabel || 'prior')
  }

  getMonthlyPensionAmount(person: IRetirementPerson, vals: INcpersPriorPensionInputs, when: moment.Moment): Promise<IMonthlyPensionPayments> {
    return Promise.resolve(this.calculateSimplePension(when, vals.pensionAmount, vals.kind, true))
  }

  getPension(): INcpersPriorPensionInputs {
    return this.profile.pension.ncpersPrior;
  }

  getPerson(): IRetirementPerson {
    return this.profile.getHeadOfHousehold();
  }
}

export {
  INcpersPriorPensionInputs,
  NCPERSPriorPensionCalculations
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/ncpers/prior/index.ts